/** Your events enum, should also be same on server */
export enum IOEventName {
    HI = 'hi',
    NEW_SALE = 'new_sale',
    NEW_ACCOMMODATION = 'new_accommodation',
    BROADCAST_MESSAGE = 'broadcast_message',
    /** A sale or accommodation was deleted - { type, id }. */
    POST_REMOVED = 'post_removed',
    /** A sale was marked sold, or for sale again - { id, sold_at }. */
    SALE_SOLD_CHANGED = 'sale_sold_changed',
    CHAT_MESSAGE = 'chat_message',
    /** The other person in a direct chat read what was sent to them - { room, reader, read_at }. */
    MESSAGES_READ = 'messages_read',
    CONNECT = 'connect',
    ERROR = 'error',
    CONNECT_ERROR = 'connect_error',
    DISCONNECT = 'disconnect',
}

/**
 * TODO: when we'd be creating a new service for a different namespace,
 * ~We'll reuse an existing socket connection or "manager" https://socket.io/docs/v4/client-options/#multiplex~
 */
export enum IOEventRoutes {
    BASE = '/',
    CHAT = '/chat',
    MAP = '/map',
    CORP_MEMBER = '/corp-member',
}
